class FilterTags {
    init() {
        $("#initiatives-extended-filter .filter").on("change input", e =>{
            let getId = e.currentTarget.id;
            FilterTags.initFilterEventHandler(getId);
        });

        $("#filter-tags").on("click", ".delete-filter-tag", e =>{
            let getParentClass = $(e.currentTarget).closest(".set-filter");
            let getId = getParentClass.data("id");
            $("#" + getId).val("");
            $(getParentClass).find(".tag").remove();
            // if($("#filter-tags").find(".tag").length == 0) {
            //     $(".close-filter").click();
            // }
            $("#initiatives").trigger("removed-filter");
        });
    }

    static initFilterEventHandler(id) {
        $(".filter-tag-" + id).remove();
        let selected = $("#" + id).val();

        if (selected != "") {
            if (id === "region" || id === "subject_area" ){
                let selectedValue = $("#" + id).val();
                selected = $("#" + id + " option[value='" + selectedValue + "']").text();
            }
            var preTag = "";
            switch (id) {
                case 'status': preTag = 'Status: '; break;
                case 'output_long': preTag = 'Ergebnis: '; break;
                case 'procedure_type': preTag = 'Verfahrenstyp: '; break;
                case 'subject_area': preTag = 'Themenbereich: '; break;
            }

            selected = preTag + selected;

            $("#filter-tags .set-filter[data-ID='" + id + "']").append('<div class="tag filter-tag-' + id + '">'+selected+'<i class="delete-filter-tag fa fa-times"></div>');
        }
    }
}

export default FilterTags;